import { render } from "./header.vue?vue&type=template&id=6477fefe&scoped=true&ts=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"

import "./header.vue?vue&type=style&index=0&id=6477fefe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6477fefe"]])

export default __exports__